import VueRouter from 'vue-router'
import Vue from 'vue'


// 将相关组件分组懒加载，减少首页加载时的请求数
const Home = () => import(/* webpackChunkName: "home" */ 'views/home/Home.vue')
const Login = () => import(/* webpackChunkName: "user" */ 'views/login/Login.vue')
const LoginWxCallBack = () => import(/* webpackChunkName: "user" */ 'views/login/LoginWxCallBack.vue')
const LoginWxBindCallBack = () => import(/* webpackChunkName: "user" */ 'views/login/LoginWxBindCallBack.vue')

// 情绪相关组件分组
const Sentiment = () => import(/* webpackChunkName: "sentiment" */ '../views/sentiment/Sentiment.vue')
const SentimentPopular = () => import(/* webpackChunkName: "sentiment" */ '../views/sentiment/SentimentPopular.vue')
const SentimentPopularCompare = () => import('../views/sentiment/SentimentPopularCompare.vue')
const SentimentCyclicality = () => import('../views/sentiment/SentimentCyclicality.vue')
const SentimentCyclicalityVIP = () => import('../views/sentiment/SentimentCyclicalityVIP.vue')
const SentimentCyclicalityYear = () => import('../views/sentiment/SentimentCyclicalityYear.vue')

const SentimentHighUplimit = () => import('views/sentiment/SentimentHighUplimit.vue')
const SentimentHot = () => import('../views/sentiment/SentimentHot.vue')
const SentimentHot2 = () => import('../views/sentiment/SentimentHot2.vue')

const ReviewOpen = () => import('../views/review/ReviewOpen.vue')
const ReviewUpLimit = () => import('../views/review/ReviewUpLimit.vue')
const ReviewUpLimitPromotion = () => import('views/review/ReviewUpLimitPromotion.vue')
const ReviewUpLimitTier = () => import('views/review/ReviewUpLimitTier.vue')
const ReviewUpLimitReason = () => import('views/review/ReviewUpLimitReason.vue')
const ReviewUpLimitProgress = () => import('views/review/ReviewUpLimitProgress.vue')
const ReviewLhb = () => import('views/review/ReviewLhb.vue')
const ReviewMovementAlert = () => import('views/review/ReviewMovementAlert.vue')
const ReviewDingpanAuction = () => import('views/review/ReviewDingpanAuction.vue')

const Robot = () => import('views/robot/Robot.vue')
const RobotHot = () => import('views/robot/RobotHot.vue')
const RobotBase = () => import('views/robot/RobotBase.vue')
const RobotVip = () => import('views/robot/RobotVip.vue')

const Wonder = () => import('views/wonder/Wonder.vue')
const WonderYjjPopular = () => import('views/wonder/WonderYjjPopular.vue')
const WonderYjjPopular2 = () => import('views/wonder/WonderYjjPopular2.vue')
const WonderYjjRate = () => import('views/wonder/WonderYjjRate.vue')
const WonderYjjRateIndustry = () => import('views/wonder/WonderYjjRateIndustry.vue')
const WonderYjjRateJX = () => import('views/wonder/WonderYjjRateJX.vue')
const WonderYjjRateML = () => import('views/wonder/WonderYjjRateML.vue')
const WonderTopicTable = () => import('views/wonder/WonderTopicTable.vue')
const WonderOpportunityMining = () => import('views/wonder/WonderOpportunityMining.vue')
const WonderUplimitLadder = () => import('views/wonder/WonderUplimitLadder.vue')
const WonderUplimitPromotionDaily = () => import('views/wonder/WonderUplimitPromotionDaily.vue')
const WonderTopicDetail = () => import('views/wonder/WonderTopicDetail.vue')
const WonderTopicFollowing = () => import('views/wonder/WonderTopicFollowing.vue')
const WonderTopicBacktest = () => import('views/wonder/WonderTopicBacktest.vue')
const WonderTopicCoreHistory = () => import('views/wonder/WonderTopicCoreHistory.vue')
const WonderAiReport = () => import('views/wonder/WonderAiReport.vue')
const WonderAiReportDetail = () => import('views/wonder/WonderAiReportDetail.vue')

const WonderJyJy = () => import('views/wonder/WonderJyJy.vue')
const WonderJy96 = () => import('views/wonder/WonderJy96.vue')
const WonderJy98 = () => import('views/wonder/WonderJy98.vue')
const WonderJy99 = () => import('views/wonder/WonderJy99.vue')
const WonderQuant = () => import('views/wonder/WonderQuant.vue')
const StrategyEditor = () => import('views/quant/StrategyEditor.vue')


const ContactUs = () => import('views/contact/ContactUs.vue')
const HallOfFame = () => import('views/contact/HallOfFame.vue')
const Feedback = () => import('views/feedback/Feedback.vue')
const UserProfile = () => import('views/user/UserProfile.vue')
const UserHome = () => import('views/user/UserHome.vue')
const SubscriptionCenter = () => import('views/user/SubscriptionCenter.vue')
const UserPostEditor = () => import('views/user/UserPostEditor.vue')
const UserPostDetail = () => import('views/user/UserPostDetail.vue')
const Followings = () => import('views/user/Followings.vue')
const Community = () => import('views/community/Community.vue')

// 后台管理
const AdminLayout = () => import('views/admin/AdminLayout.vue')
const AdminApiAuth = () => import('views/admin/AdminApiAuth.vue')
const AdminSubscription = () => import('views/admin/AdminSubscription.vue')
const AdminReferral = () => import('views/admin/AdminReferral.vue')
const AdminNotification = () => import('views/admin/AdminNotification.vue')

// 安装插件
Vue.use(VueRouter)

const routes = [{
	path: '',
	redirect: '/home',
	// component:Home,
	meta: {
		title: "自在量化-首页"
	}
},
{
	path: '/login',
	component: Login,
	meta: {
		title: "自在量化-登录"
	},
},
{
	path: '/login/wx/callback',
	component: LoginWxCallBack,
	meta: {
		title: "自在量化-登录回调"
	},
},
{
	path: '/login/wx/bind/callback',
	component: LoginWxBindCallBack,
	meta: {
		title: "自在量化-微信绑定回调"
	},
},
{
	path: '/home',
	component: Home,
	meta: {
		title: "自在量化-首页"
	}
},
{
	path: '/quant/editor',
	component: StrategyEditor,
	meta: {
		title: "Quant - Strategy Editor"
	}
},
{
	path: '/tdx/hot2',
	component: SentimentHot2,
	meta: {
		title: "情绪-热度单页"
	},
},
{
	path: '/sentiment',
	component: Sentiment,
	meta: {
		title: "情绪"
	},
	children: [{
		path: 'popular',
		component: SentimentPopular,
		meta: {
			title: "情绪-市场人气"
		},
	}, {
		path: 'popular/compare',
		component: SentimentPopularCompare,
		meta: {
			title: "情绪-人气对比"
		},
	}, {
		path: 'hot2',
		component: SentimentHot2,
		meta: {
			title: "情绪-热度单页"
		},
	}, {
		path: 'cyclicality',
		component: SentimentCyclicality,
		meta: {
			title: "情绪-周期"
		},
	}, {
		path: 'cyclicality/vip',
		component: SentimentCyclicalityVIP,
		meta: {
			title: "情绪-周期-VIP"
		},
	}, {
		path: 'cyclicality/year',
		component: SentimentCyclicalityYear,
		meta: {
			title: "情绪-周期-年"
		},
	}, {
		path: 'hot',
		component: SentimentHot,
		meta: {
			title: "情绪-热度"
		},
	}, {
		path: 'space',
		component: SentimentHighUplimit,
		meta: {
			title: "情绪-空间板"
		},
	}]
}, {
	path: '/review',
	component: ReviewOpen,
	meta: {
		title: "复盘"
	},
	children: [{
		path: "uplimit",
		meta: {
			title: "复盘-涨停梯队"
		},
		component: ReviewUpLimit
	}, {
		path: 'uplimit/up',
		redirect: '/review/uplimit/promotion'
	}, {
		path: 'uplimit/tier',
		meta: {
			title: "复盘-涨幅梯队"
		},
		component: ReviewUpLimitTier
	}, {
		path: 'uplimit/promotion',
		meta: {
			title: "复盘-涨停晋级"
		},
		component: ReviewUpLimitPromotion
	}, {
		path: 'uplimit/reason',
		meta: {
			title: "复盘-涨停原因"
		},
		component: ReviewUpLimitReason
	},
	// 添加新路由
	{
		path: 'uplimit/progress',
		meta: {
			title: "复盘-涨停板块演化"
		},
		component: ReviewUpLimitProgress
	}, {
		path: 'uplimit/lhb',
		meta: {
			title: "复盘-龙虎榜"
		},
		component: ReviewLhb
	}, {
		path: 'uplimit/alert',
		meta: {
			title: "复盘-异动提醒"
		},
		component: ReviewMovementAlert
	}, {
		path: 'uplimit/auction',
		meta: {
			title: "复盘-竞价"
		},
		component: ReviewDingpanAuction
	}]
}, {
	path: '/robot',
	component: Robot,
	meta: {
		title: "机器人说明"
	},
	children: [{
		path: "hot",
		meta: {
			title: "机器人说明-常用"
		},
		component: RobotHot
	}, {
		path: "base",
		meta: {
			title: "机器人说明-基础"
		},
		component: RobotBase
	}, {
		path: "vip",
		meta: {
			title: "机器人说明-高级"
		},
		component: RobotVip
	}]
}, {
	path: '/wonder',
	component: Wonder,
	meta: {
		title: "策略"
	},
	children: [{
		path: "",
		redirect: 'yjj/p'
	},
	{
		path: "yjj/p/:dayn?",
		component: WonderYjjPopular,
		meta: {
			title: "秘籍-易筋经-人气"
		},
	},
	{
		path: "yjj/k/:dayn?",
		component: WonderYjjPopular2,
		meta: {
			title: "秘籍-易筋经-人气"
		},
	},
	{
		path: "yjj/g/:dayn?",
		component: WonderYjjRate,
		meta: {
			title: "秘籍-易筋经-概念"
		},
	},
	{
		path: "yjj/j/:dayn?",
		component: WonderYjjRateJX,
		meta: {
			title: "秘籍-易筋经-精选"
		},
	},
	{
		path: "yjj/ml/:dayn?",
		component: WonderYjjRateML,
		meta: {
			title: "秘籍-易筋经-资金"
		},
	},
	{
		path: "topic/table",
		component: WonderTopicTable,
		meta: {
			title: "秘籍-题材表格"
		},
	},
	{
		path: "topic/following",
		component: WonderTopicFollowing,
		meta: { title: "秘籍-我的题材" },
	},
	{
		path: "topic/backtest",
		component: WonderTopicBacktest,
		meta: { title: "秘籍-题材回测" },
	},
	{
		path: "topic/core-history",
		component: WonderTopicCoreHistory,
		meta: { title: "秘籍-核心股历史" },
	},
	{
		path: "opportunity/mining",
		component: WonderOpportunityMining,
		meta: {
			title: "秘籍-机会挖掘"
		},
	},
	{
		path: "strategy/detail",
		component: () => import(/* webpackChunkName: "wonder" */ 'views/wonder/WonderStrategyDetail.vue'),
		meta: {
			title: "秘籍-策略详情"
		},
	},
	{
		path: "strategy/panorama",
		component: () => import(/* webpackChunkName: "wonder" */ 'views/wonder/WonderStrategyPanorama.vue'),
		meta: {
			title: "秘籍-策略全景解析"
		},
	},
	{
		path: "topic/detail/:id",
		component: WonderTopicDetail,
		meta: {
			title: "秘籍-题材详情"
		},
	},
	{
		path: "ai-report/detail/:id",
		component: WonderAiReportDetail,
		meta: {
			title: "秘籍-报告详情"
		},
	},
	{
		path: "ai-report/:type",
		component: WonderAiReport,
		meta: {
			title: "秘籍-AI报告"
		},
	},
	{
		path: "uplimit/ladder",
		component: WonderUplimitLadder,
		meta: {
			title: "秘籍-涨停梯队"
		},
	},
	{
		path: "uplimit/promotion/daily",
		component: WonderUplimitPromotionDaily,
		meta: {
			title: "秘籍-晋级情况"
		},
	},
	{
		path: "yjj/i/:dayn?",
		component: WonderYjjRateIndustry,
		meta: {
			title: "秘籍-易筋经-行业"
		},
	}, {
		path: "jyjy",
		component: WonderJyJy,
		meta: {
			title: "秘籍-九阴九阳"
		},
	}, {
		path: "quant/:quant",
		component: WonderQuant,
		meta: {
			title: "秘籍-分析"
		},
	}, {
		path: "96",
		component: WonderJy96,
		meta: {
			title: "秘籍-九阴主板"
		},
	}, {
		path: "98",
		component: WonderJy98,
		meta: {
			title: "秘籍-九阴之98"
		},
	}, {
		path: "98",
		component: WonderJy98,
		meta: {
			title: "秘籍-九阴之98"
		},
	}, {
		path: "99",
		component: WonderJy99,
		meta: {
			title: "秘籍-九阴之99"
		},
	}
	]
}, {
	path: '/contact',
	component: ContactUs,
	meta: {
		title: "关于-联系"
	},
}, {
	path: '/hall_of_fame',
	component: HallOfFame,
	meta: {
		title: "关于-荣誉殿堂"
	},
}, {
	path: '/community',
	component: Community,
	meta: { title: '社群' }
}, {
	path: '/feedback',
	component: Feedback,
	meta: {
		title: "关于-意见收集"
	}
}, {
	path: '/me/profile',
	component: UserProfile,
	meta: { title: '个人-资料' }
}, {
	path: '/me/home',
	component: UserHome,
	meta: { title: '个人-主页' }
}, {
	path: '/user/home/:id',
	component: UserHome,
	meta: { title: '个人-主页' }
}, {
	path: '/user/followings/:id',
	component: Followings,
	meta: { title: '个人-关注列表' }
}, {
	path: '/subscription',
	component: SubscriptionCenter,
	meta: { title: '个人-订阅中心' }
}, {
	path: '/me/post',
	component: UserPostEditor,
	meta: { title: '个人-发帖' }
}, {
	path: '/community/post/:id',
	component: UserPostDetail,
	meta: { title: '社群-帖子详情' }
}, {
	path: '/post/:id',
	component: UserPostDetail,
	meta: { title: '帖子-详情' }
}, {
	path: '/admin',
	component: AdminLayout,
	meta: { requireAdmin: true, title: '后台管理' },
	redirect: '/admin/api-auth',
	children: [
		{
			path: 'api-auth',
			component: AdminApiAuth,
			meta: { title: '后台-API权限管理' }
		},
		{
			path: 'subscription',
			component: AdminSubscription,
			meta: { title: '后台-订阅管理' }
		},
		{
			path: 'referral',
			component: AdminReferral,
			meta: { title: '后台-邀请记录' }
		},
		{
			path: 'notification',
			component: AdminNotification,
			meta: { title: '后台-站内通知' }
		}
	]
}
]
//规则
const router = new VueRouter({
	routes,
	mode: 'history'
})

// 解决发布新版后，用户加载旧版本chunk失败的问题
router.onError((error) => {
	const pattern = /Loading chunk .* failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	if (isChunkLoadFailed) {
		window.location.reload();
	}
});

// router对象传入Vue
export default router
